import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CONFIG } from '../../shared/config';
import {  HttpGeneralService } from '../../shared/shared';
let patStopDealUrl = CONFIG.baseUrls.PatStopDeal;

export interface PatientStopDeal {

    regPatientMainDataCode: number,
    startStopDeal: Date,
    endStopDeal: Date,
    stopDealReson: number,
    notes: string,
    endStopDealNgb: any,
    startStopDealNgb: any
}
@Injectable()
export class PatStopDealService {

    constructor(
        private httpGeneralService: HttpGeneralService){
    }
    //--------------------------#ibra patient Stop deal
    stopDealPatient(PatStopDeal: PatientStopDeal) {
        return this.httpGeneralService.add(PatStopDeal, `${patStopDealUrl}`);
       
    }
}

